import { USER_CODES } from 'constants/MeshbotConstant';

import { findDeviceItem } from './findDeviceItem';

/**
 * Returns the "user_codes" item of the device.
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @returns {Object} the user_codes item or {}
 */
export const getUserCodesItem = (items, deviceId) => {
    return findDeviceItem(items, deviceId, (item) => item.name === USER_CODES);
};
